// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bh-4";
export var collapsed = "_bh-1";
export var headerBar = "_bh-0";
export var leftHeaderContent = "_bh-3";
export var subjectContainer = "_bh-2";